import { render } from "./VCardPairModal.vue?vue&type=template&id=70e16cb4"
import script from "./VCardPairModal.vue?vue&type=script&lang=js"
export * from "./VCardPairModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__